import React from 'react';

const fmt = (n) => (n ?? 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Comisiones de referente (ej.: 1% del rake de IMPERIUM para SALTA POKER).
// Informativas: NO suman al TOTAL del cierre, se acreditan en la cuenta del cliente al consolidar.
export const ComisionesReferenteBadge = ({ cierre }) => (
  <>
    {(cierre.comisiones_referente || []).map((c) => (
      <div
        key={c.config_id}
        data-testid={`comision-ref-${cierre.club_id}`}
        title={`${c.pct}% de ${fmt(c.rake_pp)} PP de ${c.origen_nombre}. Informativo: no suma al TOTAL, se acredita en la cuenta del cliente al consolidar.`}
        className="mt-1 text-[11px] font-normal text-emerald-700 dark:text-emerald-400"
      >
        🤝 {c.origen_nombre} {c.pct}% · {fmt(c.monto_pp)} PP = ${fmt(c.monto_ars)}
        {c.ya_acreditado && <span className="ml-1 text-gray-400">(acreditado)</span>}
      </div>
    ))}
  </>
);

// Filas para el PDF con { label, value, isReference }
export const comisionesFilasPDF = (cierre) =>
  (cierre.comisiones_referente || []).map((c) => ({
    label: `COMISIÓN ${c.origen_nombre} (${c.pct}%) *`,
    value: `${fmt(c.monto_pp)} PP = $${fmt(c.monto_ars)}`,
    isReference: true,
  }));

// Filas para el PDF por club, formato [label, value, isNegative]
export const comisionesFilasPDFClub = (cierre) =>
  (cierre.comisiones_referente || []).map((c) => [
    `COMISIÓN ${c.origen_nombre} (${c.pct}%) *`,
    `${fmt(c.monto_pp)} PP = $${fmt(c.monto_ars)}`,
    false,
  ]);
